import React, { createContext, useContext, useState } from 'react';

interface DevToolsContextType {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggleOpen: () => void;
}

const DevToolsContext = createContext<DevToolsContextType | undefined>(undefined);

export const DevToolsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(prev => !prev);

  // Only run in DEV mode
  if (!import.meta.env.DEV) {
    return <>{children}</>;
  }

  return (
    <DevToolsContext.Provider value={{ isOpen, setIsOpen, toggleOpen }}>
      {children}
    </DevToolsContext.Provider>
  );
};

export const useDevTools = () => {
  const context = useContext(DevToolsContext);
  // Return dummy functions in prod so we don't need strict null checks everywhere
  if (!context) {
    return { isOpen: false, setIsOpen: () => {}, toggleOpen: () => {} };
  }
  return context;
};